import * as classNames from "classnames"
const clickOutside = require('react-click-outside');
import * as axios from "axios"

interface NewsLetterSignBoxProps {
    itemId: string
    componentaId: string
    onClose: () => void
    itemTitle:string
    accountName: string
}

interface NewsLetterSignBoxState {
    sendStatus: SendStatus
    checkedTerms: boolean
    mailValue: string
}
enum SendStatus {
    beforeSend = 0,
    validationError = 1,
    sent = 2,
    networkError = 3,
    sendPending = 4,
}

declare var grecaptcha: any
declare var window: any

@clickOutside
export class NewsLetterSignBox extends React.Component<NewsLetterSignBoxProps, NewsLetterSignBoxState>{
    constructor(props) {
        super(props)
        this.state = {
            sendStatus: 0,
            checkedTerms: false,
            mailValue: "",
        }
    }

    private handleClickOutside = () => {
        this.props.onClose()
    }

    private closePopUp = () => {
        this.props.onClose()
    }

    private validateEmail = (email: string) => {
        if (!email) return false;
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    private changeMailValue = (e) => {
        this.setState({ mailValue: e.target.value })
    }
    private showError = (isMailError: boolean, checkedTerms: boolean) => {
        const { sendStatus } = this.state
        let text = "";
        if (sendStatus === SendStatus.validationError) {
            if (!checkedTerms) {
                text = "נדרש לאשר הסכמה לתנאי השימוש ומדיניות הפרטיות";
            }
            if (isMailError) {
                text = "יש למלא כתובת מייל תקינה";
            }
        } else if (sendStatus === SendStatus.networkError) {
            text = "אירעה שגיאה בשליחה, נסה מאוחר יותר"
        }
        return text;
    }
    private changeTerms = () => {
        this.setState({ checkedTerms: !this.state.checkedTerms })
    }
    private onHandleSend = () => {
        const isTest = window.location.search.includes("is_test=1");
        if (isTest) {
            this.sendSub("", true);
        } else if (window.wcmCaptchaSiteKey && grecaptcha) {
            grecaptcha.ready(() => {
                grecaptcha.execute(window.wcmCaptchaSiteKey, { action: 'submit' }).then(token => {
                    this.sendSub(token, false);
                })
            })
        }
    }


    private sendSub = async (token: string, isTest: boolean) => {
        const { itemId, componentaId, itemTitle, accountName } = this.props
        const { mailValue, checkedTerms } = this.state
        let postData = {
            groupId: itemId || '',
            email: mailValue,
            token,
            accountName,
        }
        if (this.validateEmail(mailValue) && checkedTerms) {
            try {
                this.setState({ sendStatus: SendStatus.sendPending });
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({ 'event': 'GA_event', 'Category': 'Newsletter', 'Action': 'Registered to Newsletter', 'Label': itemTitle });
                const response = await axios.post(`/api/newsletter/${componentaId}/subscribeToGroup${isTest ? "?is_test=1" : ""}`, postData)
                if (response.status === 200) {
                    this.setState({ sendStatus: SendStatus.sent });
                }
            } catch {
                this.setState({ sendStatus: SendStatus.networkError })
            }
        }
        else {
            this.setState({
                sendStatus: 1
            })
        }
    }

    render() {
        const { mailValue, sendStatus, checkedTerms } = this.state
        const termsLink = <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank">תנאי השימוש</a>
        const policyLink = <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank">מדיניות הפרטיות</a>
        const emailError = sendStatus == SendStatus.validationError && !this.validateEmail(mailValue);
        const checkboxError = sendStatus === 1 && !checkedTerms ? "error" : "";
        const emailErrorClass = emailError ? "error" : "";
        const titleText = sendStatus === 2 ? "תודה!" : "הכניסו את כתובת המייל והירשמו לדיוור";
        return (
            <div className={classNames("newLetterSignUp", { "messageSent": sendStatus === 2 })}>
                <div className="closeButton" onClick={this.closePopUp}></div>
                <div className="headerImage"></div>
                <div className="popUpTitle">{titleText}</div>
                {sendStatus === 2 && <div className="popUpSubTitle">הרשמתך התקבלה בהצלחה</div>}
                {sendStatus !== 2 && <> <div className="emailInput">
                    <input placeholder="כתובת מייל" type="text" name="mail" required value={mailValue} className={emailErrorClass} onChange={this.changeMailValue} />
                    <button className="sendBtn" disabled={sendStatus === 4} onClick={this.onHandleSend}>{sendStatus === 4 ? "שולח..." : "שליחה"}</button>
                    <div className="errorMessage">{this.showError(emailError, checkedTerms)}</div>
                </div>
                    <div className="acceptTerms">
                        <input type="checkbox" id="accept-terms-newsletter" className={checkboxError} onChange={this.changeTerms} />

                        <span> מסכים/ה ל{termsLink}, {policyLink} ולקבלת פניות שיווקיות מ-ynet כולל טלפוניות, מבלי שהנ"ל מהווה הסכמה לעריכת עסקה</span>
                    </div></>}
            </div>

        )


    }
}
